export default __webpack_public_path__ + "static/media/loading.a67a3673.svg";